<template lang="pug">
.h-100
  checkbox-selector-vue(
    @checkbox:clicked="handleCheckboxEmmit",
    :checkboxList="ambitos_filter",
    :field="checkboxFieldName",
    v-if="!from_temas"
  )
</template>

<script>
import { mapMutations, mapActions } from "vuex"

export default {
  name: "hubs-search-vue",
  props: {
    hubs: { type: Array, default: () => [] },
    ambitos_filter: { type: Array, default: () => [] },
    total_documents: { type: Number, default: 0 },
    from_temas: { type: Boolean, default: false }
  },
  data() {
    return {
      checkboxFieldName: 'ambito-hub_ss'
    }
  },
  components: {
    "checkbox-selector-vue": () =>
      import(
        /* webpackChunkName: "[request]" */ "components/forms/CheckboxSelector"
      ),
  },
  methods: {
    handleCheckboxEmmit(ambitsSelected) {
      this.setLoading(true)
      this.fetchTotalDocument(ambitsSelected)
      this.setTotalDocuments(this.total_documents);
      this.filterHubs(ambitsSelected);
      this.setSelectedAmbits(ambitsSelected);
    },
    ...mapMutations(
      "hub_search",
      ["setHubs", "setTotalDocuments", "setLoading", "setSelectedAmbits", "setFromTemas"]
    ),
    ...mapActions("hub_search", ["filterHubs", "fetchTotalDocument"])
  },
  mounted() {
    this.setHubs(this.hubs);
    this.filterHubs([]);
    this.setTotalDocuments(this.total_documents);
    this.setFromTemas(this.from_temas);
  },
};
</script>
